import * as React from 'react'
import { createRoot } from 'react-dom/client'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import App from 'src/app'
import './styles/index.css'

// eslint-disable-next-line import/no-named-as-default-member
dayjs.extend(customParseFormat)

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
